import React from "react";

import { Badge } from "~/components/ui/badge";
import { PaymentBadgeProps } from "~/pages/purchase-orders/types/sales-notes";

// Status translation utility
const getStatusLabel = (status: string) => {
  const statusLabels = {
    pending: "Autorización Cobranza",
    pending_pricing: "Autorización por Precio",
    pending_credit: "Crédito Insuficiente",
    accepted: "Aprobada",
    prepaid: "Anticipado Pdte Pago",
    payment_to_check: "Validación Pago",
    por_facturar: "Por Facturar",
    in_transit: "En Tránsito",
    delivered: "Entregado",
    rejected: "Rechazada",
    test: "Test",
  };
  return statusLabels[status as keyof typeof statusLabels] || status;
};

export const PaymentBadge: React.FC<PaymentBadgeProps> = ({
  paid,
  status,
  previousStatus,
}) => {
  return (
    <Badge
      variant={
        status === "rejected" ? "destructive" : paid ? "default" : "outline"
      }
      className={
        status === "rejected"
          ? "bg-red-100 text-red-800 hover:bg-red-100"
          : paid
            ? "bg-green-100 text-green-800 hover:bg-green-100"
            : ""
      }
    >
      {status === "rejected" && previousStatus
        ? `Anterior: ${getStatusLabel(previousStatus)}`
        : paid
          ? "Pagado"
          : "Pendiente de pago"}
    </Badge>
  );
};

export default PaymentBadge;
